import React, { useEffect, useRef } from 'react';
import styles from './VoiceComponent.module.css';
import { FaMicrophone } from 'react-icons/fa';
import gsap from 'gsap';

const VoiceComponent = () => {
  const waveRef = useRef(null);
  const messagesRef = useRef(null);

  useEffect(() => {
    // Animate waveform bars
    const wave = waveRef.current;
    const bars = wave.querySelectorAll(`.${styles.bar}`);
    gsap.to(bars, {
      scaleY: () => 0.5 + Math.random() * 1.5, // Random scale between 0.5 and 2
      duration: 0.3,
      repeat: -1, // Infinite loop
      yoyo: true, // Reverse animation for smooth wave effect
      ease: 'power1.inOut',
      stagger: {
        each: 0.1, // Stagger each bar's animation
        repeat: -1,
      },
    });

    // Animate messages
    const messages = messagesRef.current.querySelectorAll(`.${styles.message}`);
    gsap.fromTo(
      messages,
      { opacity: 0, y: 20 },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.out',
        stagger: 0.2, // Stagger messages for sequential appearance
      }
    );

    // Cleanup: Kill GSAP animations on unmount
    return () => {
      gsap.killTweensOf(bars);
      gsap.killTweensOf(messages);
    };
  }, []);

  return (
    <div className={styles.container}>
      <h2 className={styles.listeningText}>Listening...</h2>
      <div className={styles.voiceChatBox}>
        <div className={styles.left}>
          <div className={styles.waveContainer} ref={waveRef}>
            {[...Array(10)].map((_, i) => (
              <div key={i} className={styles.bar}></div>
            ))}
          </div>
          <div className={styles.micButton}>
            <FaMicrophone />
          </div>
        </div>
        <div className={styles.right} ref={messagesRef}>
          <div className={`${styles.message} ${styles.received}`}>Hello!</div>
          <div className={`${styles.message} ${styles.sent}`}>Hi there!</div>
          <div className={`${styles.message} ${styles.received}`}>How can I help you?</div>
          <div className={`${styles.message} ${styles.sent}`}>Hi there!</div>
          <div className={`${styles.message} ${styles.received}`}>Hello!</div>
          <div className={`${styles.message} ${styles.sent}`}>Hi there!</div>
          <div className={`${styles.message} ${styles.received}`}>How can I help you?</div>
          <div className={`${styles.message} ${styles.received}`}>Hello!</div>
          <div className={`${styles.message} ${styles.sent}`}>Hi there!</div>
          <div className={`${styles.message} ${styles.received}`}>How can I help you?</div>
          <div className={`${styles.message} ${styles.sent}`}>Hi there!</div>
          <div className={`${styles.message} ${styles.received}`}>Hello!</div>
          <div className={`${styles.message} ${styles.sent}`}>Hi there!</div>
          <div className={`${styles.message} ${styles.received}`}>How can I help you?</div>
        </div>
      </div>
    </div>
  );
};

export default VoiceComponent;